// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","switchWrapper":"_3MslX8kD-ueh","switchBox":"_2fMYG4Opoptc"};